import React, { useContext } from 'react';

import PhotoUploadBallonMobileSvg from '../svg/PhotoUploadBallonMobileSvg';
import PhotoUploadBallonPrizeContest from '../svg/PhotoUploadBallonPrizeContest';
import PhotoUploadBallonSvg from '../svg/PhotoUploadBallonSvg';
import PhotoUploadBaloonPrizeContestMobile from '../svg/PhotoUploadBaloonPrizeContestMobile';
import AppContext from 'contexts/AppContext';

function PhotoUploadCTA({ handleClick, poi }) {
    const { state } = useContext(AppContext);
    const { photoContest } = state;
    return (
        <div>
            <div className="hidden lg:block max-w-3xl">
                {photoContest.state === 'ACTIVE' && poi?.is_in_contest ? (
                    <PhotoUploadBallonPrizeContest handleClick={handleClick} />
                ) : (
                    <PhotoUploadBallonSvg handleClick={handleClick} />
                )}
            </div>
            <div className="lg:hidden max-w-sm px-4">
                {photoContest.state === 'ACTIVE' && poi?.is_in_contest ? (
                    <PhotoUploadBaloonPrizeContestMobile handleClick={handleClick} />
                ) : (
                    <PhotoUploadBallonMobileSvg handleClick={handleClick} />
                )}
            </div>
        </div>
    );
}

PhotoUploadCTA.propTypes = {};

export default PhotoUploadCTA;
